// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Logs_markdown__Bgp0y"};